// Re-export all the imported constants
export * from './constants'

export const PAYMENT_WALL_ENABLED = import.meta.env.VITE_PAYMENT_WALL === 'true'

export const IS_MAINTENANCE_ENABLED = import.meta.env
  .VITE_IS_MAINTENANCE_ENABLED

export const NEW_DATAROOM_ENABLED = Boolean(
  import.meta.env.VITE_DATAROOM_ENABLED
)

// ENG-2033: there is no VITE_ALGOLIA_API_KEY export. The Algolia key is
// server-only; api/ reads it with process.env and the browser uses the BFF.
// These stay member reads: prefer-destructuring would rewrite them into
// `export const { ... } = import.meta.env`, which inlines every VITE_* var.
/* eslint-disable prefer-destructuring */
export const VITE_ALGOLIA_APP_ID = import.meta.env.VITE_ALGOLIA_APP_ID
export const VITE_ALGOLIA_MARKETPLACE_INDEX = import.meta.env
  .VITE_ALGOLIA_MARKETPLACE_INDEX
/* eslint-enable prefer-destructuring */
